

























































import Component from 'vue-class-component';
import { Emit, Watch } from 'vue-property-decorator';
import sitesApi from '../../../api/sites.api';
import companiesApi from '../../../api/companies.api';
import store from '../../../store/store';
import { mapGetters } from 'vuex';
import * as types from '../../../store/types';
import {
    IListItem,
    IDictionary,
    IFormControl,
    IGetLinkModel,
    AccountRole,
    AgentQuery
} from '../../../entities';
import { AgentOfficeCriteria } from '../../../components/criteria/agent-office-criteria';

@Component({
    computed: mapGetters({
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS,
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS
    })
})
export default class GenerateLinksCriteriaComponent extends AgentOfficeCriteria {
    public sites: IListItem[] = [];

    public formState: IDictionary<IFormControl> = {
        siteId: {
            key: 'siteId',
            label: 'Site',
            value: null
        },
        agentId: {
            key: 'agentId',
            label: 'Agent',
            value: null
        },
        companyId: {
            key: 'companyId',
            label: 'Office',
            value: null
        }
    };

    private sitesInProgress: boolean = false;

    public defaultFormValues(): IDictionary<any> {
        return {
            siteId: null,
            agentId: this.getDefaultOrNullAgentId(),
            companyId: this.getDefaultOrNullOfficeId()
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        if (!this.isValidData) {
            return null;
        }
        return {
            siteId: this.siteId,
            agentId: this.agentId
        };
    }

    public get inProgress() {
        return this.agentsInProgress || this.sitesInProgress;
    }

    public get isValidData() {
        return this.siteId && this.agentId;
    }

    protected get siteId(): number {
        return this.formState['siteId'].value;
    }

    protected get agentId(): number {
        return this.formState['agentId'].value;
    }

    protected set agentId(val: number) {
        this.formState['agentId'].value = val;
    }

    public created() {
        this.loadAllAgents = true;
        Promise.all([
            this._loadSites(),
            this._reloadAgents(),
            this._loadCompanies()
        ]).then(() => {
            this.doSearch();
        });
    }

    public siteChange() {
        //  this.submit();
    }

    public agentChange() {
        //   this.submit();
    }

    public companyChange() {
        this.agentId = null;
        super.companyChange();
        //    this.submit();
    }

    @Emit()
    public search(model: IGetLinkModel) {
        // empty
    }

    protected getAgentsTitle(companyName: string) {
        return 'Please select an agent';
    }

    private async _loadSites(): Promise<void> {
        this.sitesInProgress = true;
        try {
            const items = await sitesApi.list();
            const mapped = items.map((x) => {
                return { value: x.id, heading: x.sitename };
            });
            this.sites = [
                { heading: 'Please select a site', value: null },
                ...mapped
            ];
        } finally {
            this.sitesInProgress = false;
        }
    }

    @Watch('$route')
    private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }
}
